// extracted by mini-css-extract-plugin
export default {"icon":"Payment__icon___S_YFj","text":"Payment__text___frEnt","button":"Payment__button___lPO96"};